import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return StatusComponent; }),
    multi: true
};
var StatusComponent = /** @class */ (function () {
    function StatusComponent(fuseTranslationLoaderService) {
        var _this = this;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.appearance = 'outline';
        this.selectValue = new FormControl(null, [Validators.required]);
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.selectValue.valueChanges
            .pipe(debounceTime(500))
            .subscribe(function (value) {
            _this.onChange(value);
        });
    }
    StatusComponent.prototype.ngOnInit = function () {
        if (this.disabled) {
            this.selectValue.disable();
        }
    };
    StatusComponent.prototype.writeValue = function (status) {
        this.selectValue.setValue(status);
    };
    StatusComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    StatusComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    return StatusComponent;
}());
export { StatusComponent };
